import { FormikHelpers } from "formik";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import { useEditDataLineBilling } from "./api/editDataLineBilling";
import { useGetBillingViaID } from "./api/getBillingViaID";
import DataLineBillingForm from "./DataLineBillingForm";


const EditDataLineBilling = ({handleCloseModal, billingId, dataLineID}: EditDataLineBillingProps)  => {
  const getBillingViaIDQuery = useGetBillingViaID({billingId: billingId})
  const editDataLineBillingMutation = useEditDataLineBilling({data: {}, dataLineID , billingId});

  const initialValues: IEditDataLineBillingForm = {
    dbDate:  getBillingViaIDQuery.data?.dbDate ?new Date(getBillingViaIDQuery.data.dbDate) : null,
    billMonth: getBillingViaIDQuery.data?.billMonth ? getBillingViaIDQuery.data?.billMonth.toString() : "",
    billYear: getBillingViaIDQuery.data?.billYear ? getBillingViaIDQuery.data?.billYear.toString() : "",
    dbDateFrom: getBillingViaIDQuery.data?.dbDateFrom ?new Date(getBillingViaIDQuery.data.dbDateFrom) : null,
    dbDateTo: getBillingViaIDQuery.data?.dbDateTo ?new Date(getBillingViaIDQuery.data.dbDateTo) : null,
    cost: getBillingViaIDQuery.data?.cost ? getBillingViaIDQuery.data?.cost.toString() : "",
    lEnd: getBillingViaIDQuery.data?.lEnd ? getBillingViaIDQuery.data?.lEnd.toString() : "",
    comLineID: getBillingViaIDQuery.data?.comLineID ? getBillingViaIDQuery.data?.comLineID.toString() : ""
  }

  const handleSubmit = async (values: IEditDataLineBillingForm, { setSubmitting }: FormikHelpers<IEditDataLineBillingForm>): Promise<void> => {
    try {
      await editDataLineBillingMutation.mutateAsync({
        data: values,
        dataLineID: dataLineID,
        billingId: billingId
      }).then(() => {
        handleCloseModal();
      });
      
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getBillingViaIDQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getBillingViaIDQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Ελέγχου.</div>
    )
  }

  return (
    <>
      {!getBillingViaIDQuery.isLoading && getBillingViaIDQuery.data &&
        <DataLineBillingForm initialValues={initialValues} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditDataLineBillingProps {
  billingId: number;
  dataLineID: number;
  handleCloseModal: () => void;
}

export default EditDataLineBilling;